// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RocketFilledSvg from "@fishx/icons-svg/es/asn/RocketFilled";
import FishxIcon from '../components/FishxIcon';

var RocketFilled = function RocketFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RocketFilledSvg
  }));
};

RocketFilled.displayName = 'RocketFilled';
export default React.forwardRef(RocketFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RocketFilled.js
// module id = 4029
// module chunks = 0